import { useApiQuery } from "../../../hooks/useApiQuery";
import { fetchLogbookOptions } from "../api/logbookApi";

interface RawLogbookOptions {
  logbookTemplateTypes: { label: string; value: string }[];
  categoryTypes: { label: string; value: string }[];
}

interface LogbookOptions {
  types: { label: string; value: string }[];
  categories: { label: string; value: string }[];
}

const transformLogbookOptions = (response: RawLogbookOptions): LogbookOptions => ({
  types: response.logbookTemplateTypes ?? [],
  categories: response.categoryTypes ?? [],
});

export const useLogbookOptions = (enabled: boolean | undefined) => {
    return useApiQuery(['logbookOptions'], fetchLogbookOptions, {
        select: transformLogbookOptions,
        enabled: enabled,
    });
};
